import { useContext, useState } from "react";
import WithBackground from "../../../core/boilerplate/WithBackground";
import CustomToggle from "../../../helperComponents/CustomToggle";
import LoggedOutHeader from "../landingPage/LoggedOutHeader";
import styled from "styled-components";
import MaterialInput from "../../../helperComponents/MaterialInput";
import extractEventValue from "../../../../controllers/utils/extractEventValue";
import InputCard from "../../../helperComponents/InputCard";
import CustomButton from "../../../helperComponents/CustomButton";
import LoadingSection from "../../../helperComponents/LoadingSection";
import { serverLine } from "../../../../controllers/network/serverLine";
import saveUserAuth from "../../../../controllers/auth/saveUserAuth";
import { useTranslation } from "react-i18next";
import BrandContainer from "../../../brand/BrandContainer";
import Context from "../../../../Context";
import SwipeBack from "../../loggedIn/SwipeBackGesture";
import AnimatedPage from "../../loggedIn/AnimatedPage";
import AnimatedPillTabs from "../landingPage/loggedOutHomeForApp/AnimatedPillTabs";
import BadgeLogo from "../../../customUiForCs/logo/BadgeLogo";
import ColorThemeSelector from "../../loggedIn/ColorThemeSelector";
import LoggedOutBoilerplate from "../LoggedOutBoilerplate";

const HorizontalContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100vw;
  gap: 0;
  justify-content: space-between;
`;

const LeftSide = styled.div`
  display: flex;
  flex-direction: column;
  width: 50vw;
  height: 100vh;
  position: relative;
  justify-content: center;
  align-items: center;
`;

const RightSide = styled.div`
  display: flex;
  flex-direction: column;
  width: 50vw;
  height: 100vh;
  justify-content: center;
  align-items: center;
  background: var(--gradientSurface);
  border-left: 2px solid var(--surface);
`;
const Form = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
  align-items: center;
  /* padding-bottom: 30px; */
`;

const Inputs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
  /* height: 220px; */
  /* background-color: red; */
  align-items: center;
`;

const AppUIContainer = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  gap: 0;
  justify-content: center;
  align-items: center;
  padding-bottom: 40px;
`;
const ImageSectionApp = styled.div`
  border-radius: 15px;
  height: calc(100dvh - (var(--safe-area-inset-top) + 450px));
  /* height: auto; */
  /* flex: 1; */
  width: 100vw;
  object-fit: cover;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const MobileAuthSection = styled.div`
  /* position: absolute; */
  /* bottom: 0; */
  box-shadow: 0 -10px 50px 50px #000;
  padding: 0;
  width: 100vw;
  background: var(--gradientSurface);
  height: auto;
  display: flex;
  flex: 1;
  /* flex: 1; */
  max-height: 450px;
  padding-top: 15px;
  border-top: 1px solid var(--elementDim);

  justify-content: center;
  align-items: center;
  border-radius: 20px 20px 0 0;
  overflow: hidden;
`;

const Top = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  padding-top: 10px;
  background: linear-gradient(0deg, transparent, 20%, #000, #000);
  height: 80px;
`;

const ThemeSection = styled.div`
  position: absolute;
  bottom: 20px;
  left: 35%;
  width: 30%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 20px;
`;

const options = [
  { value: "LOGIN", label: "Connexion" },
  { value: "SIGNUP", label: "S'inscrire" },
];

export default function FirstSignup({ initialType }) {
  const { isMobile, themeState } = useContext(Context);
  // const [type, setType] = useState(initialType ? initialType : "LOGIN");
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const { t } = useTranslation();

  let core = (
    <InputCard submitButtonText={"Submit"} onSubmit={submit}>
      <Form>{getInputs()}</Form>
    </InputCard>
  );

  if (loading)
    core = (
      <InputCard>
        <LoadingSection />
      </InputCard>
    );

  if (isMobile) return getAppUI();

  return <LoggedOutBoilerplate>{core}</LoggedOutBoilerplate>;

  function getAppUI() {
    return (
      <SwipeBack>
        <AnimatedPage>
          <AppUIContainer>
            <WithBackground>
              <ImageSectionApp>
                <BadgeLogo />
              </ImageSectionApp>

              <MobileAuthSection>{core}</MobileAuthSection>
            </WithBackground>
          </AppUIContainer>
        </AnimatedPage>
      </SwipeBack>
    );
  }

  function submit() {
    signup();
  }

  async function signup() {
    if (!email) return window.popupAlert("Please input the email");
    if (!password) return window.popupAlert("Please input the password");

    if (password !== confirmPassword)
      return window.popupAlert("Confirm password did not match");

    try {
      setLoading(true);
      let authData = await serverLine.post("/email-signup", {
        firstName,
        lastName,
        email,
        password,
      });

      setLoading(false);
      saveUserAuth(authData);
    } catch (e) {
      setLoading(false);
      window.popupAlert(e.message);
    }
  }

  function getInputs() {
    return (
      <Inputs>
        <MaterialInput
          label={"Nom"}
          // placeholder={"Type Email Here"}
          value={lastName}
          onChange={extractEventValue(setLastName)}
        />

        <MaterialInput
          label={"Prenom"}
          // placeholder={"Type Email Here"}
          value={firstName}
          onChange={extractEventValue(setFirstName)}
        />

        <MaterialInput
          label={"Email"}
          // placeholder={"Type Email Here"}
          value={email}
          onChange={extractEventValue(setEmail)}
        />
        <MaterialInput
          type="password"
          label={"Password"}
          // placeholder={"Type Password Here"}
          value={password}
          onChange={extractEventValue(setPassword)}
        />
        <MaterialInput
          type="password"
          label={t("Confirm password")}
          // placeholder={"Type Confirm Password Here"}
          value={confirmPassword}
          onChange={extractEventValue(setConfirmPassword)}
        />
      </Inputs>
    );
  }
}
